import { render, staticRenderFns } from "./ProjectState.vue?vue&type=template&id=08a7c4f4&scoped=true&"
import script from "./ProjectState.vue?vue&type=script&lang=js&"
export * from "./ProjectState.vue?vue&type=script&lang=js&"
import style0 from "./ProjectState.vue?vue&type=style&index=0&id=08a7c4f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7c4f4",
  null
  
)

export default component.exports